export enum NivelPermissao{
    VISUALIZAR,
    GRAVAR,
    EXCLUIR
}